import React from 'react';
import { GridColDef, GridRenderCellParams } from '@mui/x-data-grid-pro';
import { ticketIdGetter } from 'components/Table/DashboardDataGridTable/value-getters/ticket-id.getter';
import { documentTypeRender } from 'components/Table/DashboardDataGridTable/render-values/document-type.render';
import { createdAtGetter } from 'components/Table/DashboardDataGridTable/value-getters/created-at.getter';
import ButtonWithArrowIcon from 'components/Buttons/ButtonWithArrowIcon';
import { DocumentTypeEnum } from 'common/document/enums/document-type.enum';
import { IReviewDocument } from '../../../../common/request/interfaces/reviewDocument';
import SearchField from '../../../../components/SearchBar';
import { Link } from 'react-router-dom';

type InputProps = {
  sendReminder: (item: IReviewDocument) => void;
  onManage: (id: string) => void;
  employeeIdLabel?: string;
  searchValue?: string;
  onSearchChange: (newValue: string) => void;
};

export const myRequestsColumns = ({
  sendReminder,
  onManage,
  employeeIdLabel = 'Employee ID',
  searchValue,
  onSearchChange,
}: InputProps): GridColDef[] => [
  {
    field: 'ticketId',
    headerName: 'Ticket ID',
    minWidth: 110,
    valueGetter: ticketIdGetter,
    align: 'left',
    headerAlign: 'left',
    type: 'number',
    renderCell: (props: any) => {
      return (
        <Link
          to={`/dashboard/drivers/${props.row.candidateId}`}
          style={{
            textDecoration: 'none',
          }}
        >
          {props.value}
        </Link>
      );
    },
  },
  {
    field: 'candidateFullName',
    headerName: 'Driver Name',
    minWidth: 150,
    renderCell: (params: GridRenderCellParams) => {
      return (
        <b
          style={{ cursor: 'pointer' }}
          onClick={() => {
            onManage(params.row.candidateId);
          }}
        >
          {params.value}
        </b>
      );
    },
  },
  { field: 'employeeId', headerName: employeeIdLabel, minWidth: 100 },
  {
    field: 'documentsNeeded',
    headerName: 'Document Type',
    minWidth: 150,
    renderCell: documentTypeRender,
    type: 'singleSelect',
    valueOptions: [
      {
        value: [DocumentTypeEnum.DRIVER_LICENSE, DocumentTypeEnum.DOT_MEDICAL],
        label: 'Compliance Docs',
      },
      {
        value: [DocumentTypeEnum.DRIVER_LICENSE],
        label: 'License Front & Back',
      },
      { value: [DocumentTypeEnum.DOT_MEDICAL], label: 'DOT Med Cert' },
      { value: [DocumentTypeEnum.RETURN_TO_WORK], label: 'Return to Work' },
      {
        value: [DocumentTypeEnum.MEDICAL_DISCONTINUANCE],
        label: 'Medical Discontinuance Form',
      },
      {
        value: [DocumentTypeEnum.PHOTO_ID],
        label: 'Photo ID',
      },
    ],
  },
  {
    field: 'submittedAt',
    headerName: 'Submitted at',
    minWidth: 180,
    valueGetter: createdAtGetter,
    type: 'dateTime',
  },
  {
    field: 'actions',
    headerName: '',
    minWidth: 180,
    align: 'right',
    renderCell: (params: GridRenderCellParams) => {
      return (
        <ButtonWithArrowIcon
          outlined={true}
          size="small"
          onClick={() => {
            sendReminder(params.row);
          }}
        >
          Send Reminder
        </ButtonWithArrowIcon>
      );
    },
    disableColumnMenu: true,
    sortable: false,
    renderHeader: () => (
      <SearchField
        placeholder={'Driver Search'}
        value={searchValue ?? ''}
        onChangeSearch={onSearchChange}
      />
    ),
  },
];
